import React, { useMemo } from "react";

const WarningIcon = ({ width = 23, height = 19 }) => {
    
  const svgContent = useMemo(() => {
    return (
      <svg
        id="Group_31144"
        data-name="Group 31144"
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 22.984 19"
      >
        <rect
          id="Rectangle_16318"
          data-name="Rectangle 16318"
          width="5"
          height="15"
          rx="2.5"
          transform="translate(9.24 4.439)"
          fill="#fff"
        />
        <path
          id="warning-svgrepo-com"
          d="M23.343,19.806,13.874,3.592a2.023,2.023,0,0,0-2.861,0L1.543,19.806a2.022,2.022,0,0,0,0,2.86h21.8a2.02,2.02,0,0,0,0-2.86ZM11.571,9.413a1.135,1.135,0,1,1,2.269,0v5.295a1.135,1.135,0,1,1-2.269,0V9.413ZM12.713,19.63A1.135,1.135,0,1,1,13.847,18.5,1.134,1.134,0,0,1,12.713,19.63Z"
          transform="translate(-0.951 -3)"
          fill="#f8a304"
        />
      </svg>
    );
  }, []);

  return svgContent;
};

export default WarningIcon;



// WEBPACK FOOTER //
// ./src/assets/WarningIcon.jsx